import { Close } from '@carbon/icons-react';
import type { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { cx } from '@/shared/lib/cx';
import s from './Feedback.module.css';
import { IconButton } from './IconButton';
import { StatusIcon, type Tone } from './status-icons';

export interface BannerProps {
  tone?: Tone;
  title?: ReactNode;
  children?: ReactNode;
  actions?: ReactNode;
  onDismiss?: () => void;
  /** Объявить сразу при появлении (ошибка отправки формы, потеря сети). */
  announce?: boolean;
  /** Во всю ширину области без скруглений (над контентом страницы). */
  inline?: boolean;
  className?: string;
}

/** Сообщение на странице: статус раздела, предупреждение о лимите, потеря сети. */
export function Banner({ tone = 'info', title, children, actions, onDismiss, announce = false, inline = false, className }: BannerProps) {
  const { t } = useTranslation('ui');
  const role = announce ? (tone === 'error' ? 'alert' : 'status') : undefined;
  return (
    <div className={cx(s.banner, s[`tone-${tone}`], inline && s.bannerInline, className)} role={role}>
      <StatusIcon tone={tone} />
      <div className={s.content}>
        {title ? <p className={s.title}>{title}</p> : null}
        {children ? <div className={s.text}>{children}</div> : null}
        {actions ? <div className={s.actions}>{actions}</div> : null}
      </div>
      {onDismiss ? <IconButton className={s.close} label={t('banner.dismiss')} icon={Close} size="sm" iconSize={16} onClick={onDismiss} tooltipPlacement="left" /> : null}
    </div>
  );
}
